import { Fragment as _Fragment, jsx as _jsx } from "react/jsx-runtime";
import { useEffect, useState } from 'react';
export function NoSSR({ loading, children }) {
    const [clientSide, setClientSide] = useState(false);
    useEffect(() => {
        setClientSide(true);
    }, []);
    return _jsx(_Fragment, { children: clientSide ? children : loading });
}
